import React, {useContext} from 'react';
import config from '../../config.js';
import UserContext from './UserContext.js';

// css
import '../../assets/bootstrap/css/bootstrap-grid.min.css';
import '../../assets/css/Footer.css';

// multilingual
import {AnchorWrap, Image, Text} from './MultilingualText.js';
import {
    aboutKeysightKey,
    blogKey,
    careersKey,
    communityKey,
    corporateSocialKey,
    discoverInsightsKey,
    diversityEquityKey,
    eventsKey,
    exploreKey,
    facebookConnectKey,
    facebookLinkKey,
    feedbackKey,
    industriesKey,
    insightsKey,
    investorRelationsKey,
    ixiaProductSupportKey,
    keysightProductSupportKey,
    keysightUniversityKey,
    linkedInConnectKey,
    manageSoftwareLicensesKey,
    mainMessages,
    modernSlaveryActKey,
    newsroomKey,
    partnersKey,
    partsKey,
    privacyKey,
    productOrderStatusKey,
    productServicesKey,
    resourcesKey,
    solutionsKey,
    successStoriesKey,
    supportKey,
    termsKey,
    twitterConnectKey,
    twitterLinkKey,
    weChatConnectKey,
    youtubeConnectKey,
    youtubeLinkKey, aboutLicensingKey
} from '../../assets/text/MultilingualText.js';


export const Footer = () => {
    const AnchorText = AnchorWrap(Text);
    const AnchorImg = AnchorWrap(Image);
    const {siteLanguageDefault} = useContext(UserContext);
    const currentYear = new Date().getFullYear();
    return (
        <>
            <div id="footer" style={{
                fontSize: '0.75rem',
                color: 'var(--color-text-secondary)',
            }}>
                <div className="wrapper">
                    <div id="copyright">
                        <ul>
                            <li>&copy; Keysight Technologies
                                2000&ndash;{currentYear}
                            </li>
                            <li>
                                <AnchorText
                                    href={config.keysight + "us/en/contact/privacy.html"}
                                    data-location="Footer"
                                    data-name="Footer"
                                    data-trigger="false"
                                    data-parentvalue="Footer"
                                    textkey={privacyKey}
                                    textdefault={mainMessages[siteLanguageDefault][privacyKey]}
                                />
                            </li>
                            <li>
                                <AnchorText
                                    href={config.keysight + "us/en/contact/terms-of-use.html"}
                                    data-location="Footer"
                                    data-name="Footer"
                                    data-trigger="false"
                                    data-parentvalue="Footer"
                                    textkey={termsKey}
                                    textdefault={mainMessages[siteLanguageDefault][termsKey]}
                                />
                            </li>
                            <li>
                                <AnchorText
                                    href={config.keysight + "us/en/contact/support/site-feedback.html"}
                                    data-location="Footer"
                                    data-name="Footer"
                                    data-trigger="false"
                                    data-parentvalue="Footer"
                                    textkey={feedbackKey}
                                    textdefault={mainMessages[siteLanguageDefault][feedbackKey]}
                                />
                            </li>
                            <li>
                                <AnchorText
                                    href={config.keysight + "us/en/contact/support.html"}
                                    data-location="Footer"
                                    data-name="Footer"
                                    data-trigger="false"
                                    data-parentvalue="Footer"
                                    textkey={supportKey}
                                    textdefault={mainMessages[siteLanguageDefault][supportKey]}
                                />
                            </li>
                            <li>
                                <AnchorText
                                    href={config.keysight + "us/en/lib/resources/selection-guides/" +
                                        "keysight-licensing-overview-terms-and-types.html#LicensingOverview"}
                                    data-location="Footer"
                                    data-name="Footer"
                                    data-trigger="false"
                                    data-parentvalue="Footer"
                                    textkey={aboutLicensingKey}
                                    textdefault={mainMessages[siteLanguageDefault][aboutLicensingKey]}
                                />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Footer;